import { render } from "./DealTrustee.vue?vue&type=template&id=0a1d71fe&scoped=true"
import script from "./DealTrustee.vue?vue&type=script&lang=js"
export * from "./DealTrustee.vue?vue&type=script&lang=js"

import "./DealTrustee.vue?vue&type=style&index=0&id=0a1d71fe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1d71fe"]])

export default __exports__